import {
  ApiClientFactory
} from '../ApiClientFactory';
import {
  API_URL
} from '../Variables';

let clientFactory = new ApiClientFactory();

export const DocumentClient = {
  /**
   * Returns a document with the provided id.
   *
   * @param {Integer} id
   */
  getDocument(id) {
    return clientFactory.get(API_URL + 'document/' + id);
  },
  /**
   * Returns all documents belonging to a user
   */
  getUserDocuments() {
    return clientFactory.get(API_URL + 'user/documents/');
  },
  getUserProjectDocument(project_id) {
    return clientFactory.get(API_URL + 'user/documents/project/' + project_id);
  },
  createDocument(type = 'journal') {
    return clientFactory.post(API_URL + 'document/create', {
      type: type
    });
  },
  deleteDocument(documentId) {
    return clientFactory.delete(API_URL + 'document/' + documentId)
  },
  updateDocument(document) {
    return clientFactory.post(
      API_URL + 'document/' + document.id + '/update',
      document
    );
  },
  deleteAttachment(payload) {
    return clientFactory.delete(
      API_URL +
      'document/' +
      payload.document.id +
      '/attachment/' +
      payload.attachment_id,
      document
    );
  },
  createDocumentComment(documentId, body) {
    return clientFactory.post(
      API_URL + 'document/' + documentId + '/comments', {
        body: body,
      }
    );
  },
  addToForum(document, forum) {
    return clientFactory.post(
      API_URL + 'document/' + document.id + '/addtoforum',
      forum
    );
  },
};